import { reportJsonParseException } from '@/src/common/exception';
import {
  GroupItem, SkuItem, Spu, addItemActivityTypeItem, ShopInfo, ShopAbnormalInfo
} from '../component';
import i18nClient from '../locales/i18n.config';
import TrackUtils from './TrackUtils';
import { SHOP_ACTIVITY_TYPE, SPU_LIST_SOURCE } from './constant';

const Toast = Mach.requireModule('Toast');
const Storage = Mach.requireModule('Storage');
const Intl = Mach.requireModule('Intl');

export function convertGroupSkuId(groupItems: GroupItem[]) {
  const groupSkuList: number[] = [];
  groupItems?.map((groupItem) => {
    groupItem?.groupSkuList?.map((groupSku) => {
      groupSkuList.push(groupSku?.groupSkuId);
    });
  });
  return groupSkuList;
}

/**
 * groupSku新增count
 * @param groupItems
 * @returns
 */
export function convertGroupSkuIdNCount(groupItems: GroupItem[]) {
  const groupSkuList: { groupSkuId: number; count: number; }[] = [];
  groupItems?.map((groupItem) => {
    groupItem?.groupSkuList?.map((groupSku) => {
      groupSkuList.push({ groupSkuId: groupSku?.groupSkuId, count: groupSku?.count });
    });
  });
  return groupSkuList;
}

/**
 * sku的groupSkuId转为string (skuid + 排序的List<groupSkuId> +remark 唯一值)
 * 1.7更新groupSku列表基本元素{groupSkuId:number, count:number}
 * @param sku
 */
export function fromatSkuStr(sku: SkuItem): string {
  const groupSkuIdList: { groupSkuId: number; count: number; }[] = [];
  (sku.groupList || []).forEach((groupItem: GroupItem) => {
    groupItem.groupSkuList.forEach((groupSku) => {
      groupSkuIdList.push({ groupSkuId: groupSku.groupSkuId, count: groupSku.count || 1 });
    });
  });
  const sortGroupSkuIdList = groupSkuIdList.sort((a, b) => a.groupSkuId - b.groupSkuId);
  let groupSkuIdListStr = '';
  for (let i = 0; i < sortGroupSkuIdList.length; i++) {
    groupSkuIdListStr = `${groupSkuIdListStr}&${sortGroupSkuIdList[i].groupSkuId}*${sortGroupSkuIdList[i].count}`;
  }
  const remark = sku.remark ? sku.remark : '';
  const skuStr = `${sku.skuId}${groupSkuIdListStr}${remark}`;
  return skuStr;
}

export const jumpToDetail = (spu: Spu, isCartError: boolean, showGoodDetail) => {
  TrackUtils.spuItemMCTag(spu);
  if (isCartError) {
    Toast.show(i18nClient.getText('shop_cart_noservice3'), 2);
    return;
  }
  if (spu.availableStatus === 1) {
    showGoodDetail({ spu });
  } else if (spu.availableStatus === 0) {
    Toast.show(i18nClient.getText('shop_card_rest3'), 2);
  } else {
    console.log('invalid spu');
  }
};

/**
 * 是否展示商品活动价格
 * @param noDiscountSkuTotalPrice 购物车非折扣商品总价
 * @param noDiscountSkuPrice 当前非折扣菜原价
 * @param limitAmount 门店满折活动价格限价
 */
export const handleIsActivityMet = (
  noDiscountSkuTotalPrice: number = 0,
  noDiscountSkuPrice: number = 0,
  limitAmount: number = 0
) => noDiscountSkuTotalPrice + noDiscountSkuPrice >= limitAmount;

/** 加购后列表内是否展示非折扣商品活动价
 * @param list 商品列表
 * @param foodListStatusMap 商品状态map
 * @param state global state
 * @param type 列表类型 'FoodList' | 'ShopWindow'
 */
export const handleActivityPrice = (list, foodListStatusMap, state, type) => {
  if (!list || !list.length) return;

  const { calculateOut, shopInfo } = state;

  // 满折活动价格限价（比如满100打7折），后续可能会有多阶梯活动价
  const shopActivityItem = shopInfo?.shopActivityList?.find(
    (item) => item.activityType === SHOP_ACTIVITY_TYPE.FULL_DISCOUNT
  );
  /** 门店满折多阶梯活动价格限价 */
  const limitPriceList = Array.isArray(shopActivityItem?.limitPriceList) ? shopActivityItem?.limitPriceList : [];

  const isShopWindow = type === SPU_LIST_SOURCE.SHOP_WINDOW;
  const isFoodList = type === SPU_LIST_SOURCE.SHOP_LIST;
  const isShopSearch = type === SPU_LIST_SOURCE.SHOP_SEARCH;

  // 处理单个spu 判断是否展示原价和划线价
  const _handleSpuItem = (spu) => {
    const spuId = spu.spuId;
    // 是否为折扣菜 spu.activityInfoList?.[0]取数组中的第0个，目前只有一种活动，后续可能会有多种活动（按照包含的逻辑处理）
    const isDiscountFood = spu.activityInfoList?.[0]?.activityType === SHOP_ACTIVITY_TYPE.DISCOUNT_FOOD;
    let foodListStatusMapEntry = {
      /** 是否参与折扣菜活动 */
      isActivityMet: isDiscountFood,
      /** isActivityMet为true的情况下，展示当前菜品参与活动第n个阶梯的价格，默认为0 */
      discountPriceIndex: 0,
      spu,
    };
    if (foodListStatusMap[spuId] !== undefined) {
      foodListStatusMapEntry = {
        ...foodListStatusMap[spuId],
        ...foodListStatusMapEntry,
      };
    }
    // 不是折扣菜，且有门店满折活动限价，且当前菜品参加了满折活动
    const isFullDiscountFood = spu.activityInfoList?.[0]?.activityType === SHOP_ACTIVITY_TYPE.FULL_DISCOUNT;
    if (isFullDiscountFood) {
      /** 购物车非折扣菜商品总价 */
      const noDiscountSkuTotalPrice = calculateOut.noDiscountSkuTotalPrice?.amount || 0;
      /** 当前非折扣菜原价 */
      const minPrice = spu.minPrice?.amount || 0;
      foodListStatusMapEntry.isActivityMet = false;
      // 满折多阶梯逻辑
      limitPriceList.forEach((item, index) => {
        /** 购物车非折扣商品总价 + 当前非折扣菜原价 >= 门店满折多阶梯活动价格限价 */
        if (handleIsActivityMet(noDiscountSkuTotalPrice, minPrice, item.amount)) {
          /** isActivityMet: 是否满足满折条件（不满足满折条件展示： 满X可享） */
          foodListStatusMapEntry.isActivityMet = true;
          /** discountPriceIndex 展示第n个阶梯的折扣价 */
          foodListStatusMapEntry.discountPriceIndex = index;
        }
      });
    }
    foodListStatusMap[spuId] = foodListStatusMapEntry;
  };
  // 因商品橱窗和商品列表的数据结构不同，需要分别处理
  isFoodList
    && list?.forEach((category) => {
      category?.sectionData?.spuList.forEach((spu) => {
        _handleSpuItem(spu);
      });
    });

  isShopWindow
    && list?.forEach((spu) => {
      _handleSpuItem(spu);
    });

  if (isShopSearch) {
    list.forEach((spuList) => {
      spuList?.data?.forEach((spuArr) => {
        spuArr?.data?.forEach((spu) => {
          _handleSpuItem(spu);
        });
      });
    });
  }
};

/**
 * 购物车活动横条动画模板
 */
export const cartActBarAniTemp = {
  duration: '300ms',
  iterationCount: 1,
  direction: 'normal',
  timingFunction: 'ease-in-out',
  fillMode: 'forward',
  transformOrigin: 'left top',
  delay: '2s',
  keyFrames: {
    from: { transform: 'translateY(0)' },
    to: { transform: 'translateY(-50)' },
  },
};

/**
 * 查找凑单最低价
 */
export const findMinDiffPrice = (diffPriceArr: addItemActivityTypeItem[]) => {
  if (diffPriceArr.length === 0) {
    return 0;
  }
  let minDiffPrice = diffPriceArr[0]?.amount;
  diffPriceArr.forEach((item) => {
    if (item.amount < minDiffPrice) {
      minDiffPrice = item.amount;
    }
  });
  return minDiffPrice;
};

/**
 * 获取该设备是否有已弹出收藏提示
 */
export const hasShownFavouriteTipsView = () => {
  const hasShown = Storage.getBool({
    channel: 'mach',
    key: 'favourite_tips_view_status',
  });
  return hasShown;
};

/**
 * 根据需要存储收藏提示引导状态
 */
export const storeFavouriteTipsViewShownIfNeed = () => {
  const hasShown = hasShownFavouriteTipsView();
  if (!hasShown) {
    storeFavouriteTipsViewShown();
  }
};

/**
 * 存储收藏提示引导状态
 */
export const storeFavouriteTipsViewShown = () => {
  Storage.setBool({
    channel: 'mach',
    key: 'favourite_tips_view_status',
    value: true,
  });
};

/**
 * 根据需要存储收藏弹窗展示
 */
export const storeFavouritePopViewShownIfNeed = () => {
  const hasShown = hasShownFavouritePopView();
  if (!hasShown) {
    storeFavouritePopViewShown();
  }
};

/**
 * 存储收藏成功提示状态
 */
export const storeFavouritePopViewShown = () => {
  Storage.setBool({
    channel: 'mach',
    key: 'favourite_pop_view_status',
    value: true,
  });
};

/**
 * 判断是否显示收藏弹窗视图
 */
export const hasShownFavouritePopView = () => {
  const hasShown = Storage.getBool({
    channel: 'mach',
    key: 'favourite_pop_view_status',
  });
  return hasShown;
};

/**
 * 转换RTL文案
 * @param text
 * @returns
 */
export const getTransformRTLText = (text) => {
  let transformText = text;
  if (transformText && Intl?.isRTL?.() && Intl?.unicodeRtl) {
    transformText = Intl.unicodeRtl(transformText);
  }
  return transformText;
};

export const debounce = (fn, timeout = 200) => {
  let timer;
  return function (this, ...args: any[]) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, timeout);
  };
};

export const throttle = (fn, timeout = 200) => {
  let timer;
  let lastTime;
  let thisArg;
  const execute = (args) => {
    fn.apply(thisArg, args);
    lastTime = Date.now();
  };

  return function (this, ...args: any[]) {
    thisArg = this;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (!lastTime) {
      return execute(args);
    }
    const diff = Date.now() - lastTime;
    if (diff > timeout) {
      return execute(args);
    }
    timer = setTimeout(() => {
      execute(args);
    }, timeout);
  };
};

/**
 * JSON解析，若入参为空则直接返回{}
 */
export const safeJSONParse = (parseStr) => {
  if (typeof parseStr !== 'string') {
    return {};
  }
  let parseJSON;
  try {
    parseJSON = JSON.parse(parseStr);
  } catch (error) {
    // 捕获到异常上报
    reportJsonParseException(error);
  }
  return parseJSON;
};

/**
 * 根据逗号分割字符串(中文、英文、阿拉伯语逗号)
 */
export function splitWithLeadingComma(text) {
  const commaRegex = /([，,،])/g;
  const segments: string = text.split(commaRegex);
  const result: string[] = [];
  if (!text) {
    return result;
  }
  let pendingComma = '';
  let isFirst = true;

  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];

    if (commaRegex.test(segment)) {
      pendingComma = segment;
    } else {
      if (isFirst) {
        result.push(segment);
        isFirst = false;
      } else {
        result.push((pendingComma || '') + segment);
        pendingComma = '';
      }
    }
  }

  return result;
}

/**
 * 获取门店橱窗ab实验
 */
export const getShopWindowsABTest = (shopInfo: ShopInfo) => {
  const expGroupKey = 'shop_windows_ab_test_exp1';
  let expKey;
  shopInfo?.expInfoList?.forEach((item) => {
    if (item.groupKey === expGroupKey) {
      expKey = item.expKey;
    }
  });
  if (expKey === 'A' || expKey === 'B') {
    return true;
  }
  return false;
};

/**
 * 获取门店信息问题治理ab实验
 */
export const getShopInfoQualityABTest = (shopInfo: ShopInfo) => {
  const expGroupKey = 'Store_Info_Quality_AB_Test_exp1';
  let expKey;
  shopInfo?.expInfoList?.forEach((item) => {
    if (item.groupKey === expGroupKey) {
      expKey = item.expKey;
    }
  });
  if (expKey === 'A') {
    return true;
  }
  return false;
};

/*
 * 判断是否超配
 * 前端使用时需要先判断shopAbnormalInfo是否为空、字段里的abnormalType、abnormalText都不能为空才行
 */
export const isAbnormalInfoValid = (shopAbnormalInfo?: ShopAbnormalInfo) => !!shopAbnormalInfo
  && !!shopAbnormalInfo.abnormalType
  && !!shopAbnormalInfo.abnormalText.trim();
